/*
Developers: Sakshi Bhise
File: AuthFailed.tsx
Date: 06/18/2025
Project Name: AskHR
Team: DSET

Purpose:
This component displays a simple Authentication Failed error message for any route not found
within the AskHR portal. It helps handle undefined paths gracefully, improving
the user experience when navigating to incorrect or missing pages.
*/

// ======================== Imports ======================== //  
// Import the CSS module for scoped styles  
import styles from "./layout/Layout.module.css";  
// Import the AskHR logo image asset  
import AskHR from "../assets/AskHR w Teva logo.png";  
  
// ======================== Component ======================== //  
/**  
 * AuthFailed  
 * Displays a user-friendly message when authentication fails.  
 */  
const AuthFailed = () => {  
  // ======================== Render ======================== //  
  return (  
    <>  
      {/* ---------- Header Section (Logo) ---------- */}  
      <div className={styles.headerStackContainer}>  
        <div style={{  
          display: 'flex',  
          alignItems: 'center',  
          marginTop: "15px" // Spacing from the top  
        }}>  
          {/* Logo image for brand recognition */}  
          <img  
            src={AskHR}  
            style={{ height: '90px' }} // Fixed height for consistent branding  
            aria-hidden="true"         // Decorative, not announced by screen readers  
          />  
        </div>  
      </div>  
  
      {/* ---------- Centered Message Section ---------- */}  
      <div  
        style={{  
          minHeight: '100vh',             // Full viewport height, so message is centered  
          display: 'flex',                // Flex layout for centering  
          flexDirection: 'column',        // Stack vertically  
          alignItems: 'center',           // Center horizontally  
          justifyContent: 'center',       // Center vertically  
          fontFamily: 'Segoe UI, sans-serif', // Consistent font with rest of app  
          background: '#fff',             // White background for clarity  
          padding: '0'                    // No extra padding  
        }}  
      >  
        {/* ---------- Error Message ---------- */}  
        <div style={{  
          fontSize: 32,                   // Large, readable headline  
          color: '#333',                  // Dark gray for good contrast  
          textAlign: 'center',            // Center text for clarity  
          maxWidth: 470,                  // Prevents very long lines, improves readability  
          margin: '0 auto',               // Horizontal centering  
          lineHeight: 1.5                 // Comfortable line spacing  
        }}>  
          Authentication failed. Please try again. If the problem persists, contact the service desk for assistance.  
        </div>  
      </div>  
    </>  
  );  
};  
  
// Export the component for use elsewhere in the app  
export default AuthFailed;  